import React, { useEffect } from 'react';
import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './styles.less';
import useSessionStorage from 'utils/hooks/useSessionStorage';

const unauthorizedOccurencesCounterKey = 'UNAUTHORIZED_OCCURENCES_COUNTER_KEY';

const NotAuthenticated = () => {
  const { t } = useTranslation();
  const [unauthorizedCount, setUnauthorizedCount] = useSessionStorage(
    unauthorizedOccurencesCounterKey,
    0,
  );

  const showTroubleshootSection = unauthorizedCount > 2;

  useEffect(() => {
    setUnauthorizedCount((p) => p + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleButtonClick = () => {
    window.location.reload();
  };

  return (
    <div className="unauthorized-page__container">
      <div className="unauthorized-page__element">
        <span className="unauthorized-page__number">401</span>
        <p className="unauthorized-page__title">{t('unauthorized.title')}</p>
        <p className="unauthorized-page__content">{t('unauthorized.content')}</p>
        {showTroubleshootSection && (
          <Alert
            className="unauthorized-page__alert"
            type="info"
            description={t('unauthorized.troubleshoot')}
            showIcon
          />
        )}
        <Button className="unauthorized-page__button" type="primary" onClick={handleButtonClick}>
          {t('forms.retry')}
        </Button>
      </div>
    </div>
  );
};

export default NotAuthenticated;
